import { SearchtoolboxService } from './../../_services/searchtoolbox.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Observable, Subject } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-smartsearch',
  templateUrl: './smartsearch.component.html',
  styleUrls: ['./smartsearch.component.scss']
})

export class SmartsearchComponent implements OnInit {
  totalcustomresults: any;
  recordidForPlatform: any;
  searchresultPlatform: any;
  searchresultBooleanSearchUrl: any;
  deselectedjobtitlesarray: any[] = [];
  deselectedskillsarray: any[] = [];
  companiesBooleanString: any;
  industriesBooleanString: any;
  locationsBooleanString: any;
  mandatorySkillsBooleanString: any;
  preferredSkillsBooleanString: any;
  jobTitlesBooleanString: any;
  history: boolean;
  searchtoolboxhistory: any;
  totalcount: any;
  total_count: any;
  total: any;
  start: number = 0;
  end: any;
  platformselected:any = 'All';

  constructor(public searchtoolbox: SearchtoolboxService,
    private router: Router,private _localstorageservice : LocalStorageService ) { }

  jobtitlearraylist: Array<any>;
  skillsarraylist: Array<any>;
  industryarraylist: Array<any>;
  locationarraylist: Array<any>;
  companyarraylist: Array<any>;
  filteredJobTitleOptions: any;
  filteredSkillsOption: any;
  filteredIndustryOption: any
  filteredLocationOption: any
  filteredCompanyOption: any
  jobtitle: string[] = [];
  industry: string[] = [];
  location: string[] = [];
  companies: string[] = [];
  preferredskills: string[] = [];
  mandatoryskills: string[] = [];
  recommendedjobtitle: any[] = [];
  recommendedskills: any[] = [];
  BooleanString: any;
  BooleanStringToDisplay: any;
  booleanSearchURLsArray: any;
  searchresult: any[] = [];
  startIndex: any;
  searchresultnextpage: any;
  CustomSearchPlatForm: any
  FormError: boolean;
  resultdiv: boolean;
  toStr = JSON.stringify;
  autocomplete_company:boolean = true


  ngOnInit() {
    // this.getautocompleteData()
  }

  getautocompleteData(type,input): Observable<any> {
    let data ={
      "dropdowntype": type,
      "searchedstring": input
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        subject.next(res.data);
      }else{
        subject.next([])
      }
    })
    return subject.asObservable();
  }

  searchAutoCompletedData(event, type) {
    if(event.query.trim().toLowerCase()!=''){
    if (type == 'Job Title') {
      if (event.query.length > 2) {
        this.getautocompleteData('job titles',event.query).subscribe((res)=>{
          this.filteredJobTitleOptions  = res
        })
      }
    } else if (type == 'Skill') {
      if (event.query.length > 2) {
        this.getautocompleteData('skills',event.query).subscribe((res)=>{
          this.filteredSkillsOption  = res
        })
      }
    } else if (type == 'Industry') {
      if (event.query.length > 2) {
        this.getautocompleteData('industries',event.query).subscribe((res)=>{
          this.filteredIndustryOption  = res
        })
      }
    } else if (type == 'Location') {
      if (event.query.length > 2) {
        this.getautocompleteData('locations',event.query).subscribe((res)=>{
          this.filteredLocationOption  = res
        })
      }
    }
    else if (type == 'Company') {
      if (event.query.length > 2  && this.autocomplete_company) {
        this.autocomplete_company = false
        this.getautocompleteData('companies',event.query).subscribe((res)=>{
          this.filteredCompanyOption  = res
          this.autocomplete_company = true

        })
      }
    }
  }

  }

  OnEnterAddChip(event, type) {
    if (event.target.value && event.key == "Enter" && event.target.value.toString().trim().toLowerCase() != '') {
      event.target.value = event.target.value.toString().trim().toLowerCase()
      if (type == 'Job Title') {
        this.jobtitle.push(event.target.value);
        this.getRelatedData(type, event.target.value)
        event.target.value = ''
      } else if (type == 'Skill') {
        this.preferredskills.push(event.target.value);
        this.getRelatedData(type, event.target.value)
        event.target.value = ''
      } else if (type == 'Mandatory Skill') {
        this.mandatoryskills.push(event.target.value);
        this.getRelatedData('Skill', event.target.value)
        event.target.value = ''
      } else if (type == 'Location') {
        this.location.push(event.target.value);
        this.filteredLocationOption = []
        event.target.value = ''
      } else if (type == 'Company') {
          let companynameobj;
            companynameobj={
              company_name : event.target.value
            }
          this.companies.push(companynameobj)
          this.filteredCompanyOption = []
          event.target.value = ''
      }
    }
  }

  UnselectAutoCompleteChip(event,type){
   if (type == 'Job Title') {
     this.deselectedjobtitlesarray.push(event)
      this.getRelatedData(type, event , 'remove')
    } else if (type == 'Skill') {
     this.deselectedskillsarray.push(event)
      this.getRelatedData(type, event, 'remove')
    }
  }

  selectAutoCompleteChip(event, type) {
    if (type == 'Job Title') {
      this.getRelatedData(type, event)
    } else if (type == 'Skill') {
      this.getRelatedData(type, event)
    }
  }

  AddChipValueToAutoComplete(i, value, type) {
    value = value.toString().trim().toLowerCase()
    if (type == "Job Title") {
      this.recommendedjobtitle.splice(i, 1);
      this.jobtitle.push(value);
      this.getRelatedData(type, value)
    } else if (type == "Skill") {
      this.recommendedskills.splice(i, 1);
      this.preferredskills.push(value);
      this.getRelatedData(type, value)
    } else if (type == "Mandatory Skill") {
      this.recommendedskills.splice(i, 1);
      this.mandatoryskills.push(value);
      this.getRelatedData('Skill', value)
    }
  }

  getRelatedData(type: string, value: string , action?) {
    let data={
      searchparameter: type,
      searchedstring: value.toString().trim().toLowerCase(),
      selectedjobtitlesarray: this.jobtitle.filter((x)=>{return x != value}),
      selectedskillsarray : [...this.preferredskills, ...this.mandatoryskills].filter((x)=> {return x != value}),
      existingjobtitlessuggestionarray: this.recommendedjobtitle,
      existingskillssuggestionarray: this.recommendedskills,
      deselectedjobtitlesarray:this.deselectedjobtitlesarray,
      deselectedskillsarray:this.deselectedskillsarray
    }
    if(action == 'remove' && type == 'Job Title'){
      let selectedjob = data['selectedjobtitlesarray']
      data['searchedstring'] = selectedjob.length ? selectedjob[selectedjob.length - 1] : ''
      data['searchparameter'] = 'Job Title'
    }else if(action == 'remove' && type == 'Skill'){
      let selectedskill = data['selectedskillsarray']
      data['searchedstring'] = selectedskill.length ? selectedskill[selectedskill.length - 1] : ''
      data['searchparameter'] = 'Skill'
    }
    
    this.searchtoolbox.recommendedData(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.recommendedjobtitle = res.data.related_job_titles
        this.recommendedskills = res.data.related_skills.filter((x)=> x)
        this.filteredJobTitleOptions = []
        this.filteredSkillsOption = []
      }
    });
  }


  searchwithoutBoolean(type, stage){
    let platformselected = type
    this.skipbooleanstring(platformselected,'stage')
  }


  skipbooleanstring(platform,type) {
    if (this.jobtitle.length > 0 && this.preferredskills.length > 0 && (this.preferredskills.length + this.mandatoryskills.length) > 2) {
      this.FormError = false
      let data = {
        industries: this.industry,
        jobTitles: this.jobtitle,
        locations: this.location,
        mandatorySkills: this.mandatoryskills,
        preferredSkills: this.preferredskills,
        companies: this.companies.length > 0 ? this.companies.map(value => value['company_name']) : null,
        userID:this._localstorageservice.getItem('userid')
      }

      this.searchtoolbox.createBooleanSearch(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.recordidForPlatform = res.data.recordID
          this.BooleanString = res.data.generatedBooleanStringWithJobTitles ? res.data.generatedBooleanStringWithJobTitles : res.data.generatedBooleanStringWithoutJobTitles
          this.BooleanStringToDisplay = this.BooleanString        // to change Color for Operators
          this.booleanSearchURLsArray = res.data.booleanSearchURLsArray
          this.companiesBooleanString = res.data.companiesBooleanString
          this.industriesBooleanString = res.data.industriesBooleanString
          this.locationsBooleanString = res.data.locationsBooleanString
          this.mandatorySkillsBooleanString = res.data.mandatorySkillsBooleanString
          this.preferredSkillsBooleanString = res.data.preferredSkillsBooleanString
          this.jobTitlesBooleanString = res.data.jobTitlesBooleanString


          if (platform== "all") {
            this.CustomSearchPlatForm = 'All'
            window.scrollTo(0, 0)
            this.GoogleCustomSearchAPI('Initial')
            this.savePlatformAccessDetails(platform)  /// to save access platform details
          }
          else {
            let tempurl = this.booleanSearchURLsArray.filter((x)=>{return x.platform == platform})
            window.open(tempurl[0].booleanSearchURL, "_blank");
            this.savePlatformAccessDetails(platform)  /// to save access platform details
          }
          if (platform== "all" && type == 'update') {
            this.searchresult = []
            this.platformselected = 'All';
            this.GoogleCustomSearchAPI('Initial')
          }
        }
      })
    }
    else {
      this.FormError = true
    }
  }

  nextpage() {
    this.GoogleCustomSearchAPI('nextpage')
  }

  selectBooleanSearchUrl(event) {
    let searchresult = JSON.parse(event.target.value)
    this.searchresultPlatform = searchresult.platform
    this.searchresultBooleanSearchUrl = searchresult.booleanSearchURL
  }

  selectBooleanSearchPlatform(value){
    let searchresult = JSON.parse(value)
    this.searchresultPlatform = searchresult.platform
    this.searchresultBooleanSearchUrl = searchresult.booleanSearchURL

    if (this.searchresultPlatform == "Search across the web") {
      this.CustomSearchPlatForm = 'All'
      this.GoogleCustomSearchAPI('Initial')
      this.savePlatformAccessDetails(this.searchresultPlatform)  /// to save access platform details
    }
    else if (this.searchresultBooleanSearchUrl){
      window.open(this.searchresultBooleanSearchUrl, "_blank");
      this.savePlatformAccessDetails(this.searchresultPlatform)  /// to save access platform details
    }
    else{

    }
  }


  searchPlatform(){
    if (this.searchresultPlatform == "Search across the web") {
      this.CustomSearchPlatForm = 'All'
      this.GoogleCustomSearchAPI('Initial')
      this.savePlatformAccessDetails(this.searchresultPlatform)  /// to save access platform details
    }
    else if (this.searchresultBooleanSearchUrl){
      window.open(this.searchresultBooleanSearchUrl, "_blank");
      this.savePlatformAccessDetails(this.searchresultPlatform)  /// to save access platform details
    }
    else{

    }
  }


  SelectSearchPlatform(event) {
    this.searchresult = []  //to make Previous Array Null
    this.CustomSearchPlatForm = event.target.value
    this.GoogleCustomSearchAPI('Initial')

    this.savePlatformAccessDetails(event.target.value)   /// to save access platform details
  }


  GoogleCustomSearchAPI(type) {
    if (type == 'Initial') {
      this.startIndex = 1
    } else if (type == 'nextpage') {
      this.startIndex = this.startIndex + 10
    }

    let data = {
      selectedplatform: this.CustomSearchPlatForm,
    	searchedquery: this.BooleanString,
      startindex: this.startIndex,
      companiesBooleanString: this.companiesBooleanString,
      industriesBooleanString: this.industriesBooleanString,
      locationsBooleanString: this.locationsBooleanString,
      mandatorySkillsBooleanString: this.mandatorySkillsBooleanString,
      preferredSkillsBooleanString: this.preferredSkillsBooleanString,
      jobTitlesBooleanString:this.jobTitlesBooleanString
    }

    this.searchtoolbox.googleSearchApi(data).subscribe((res: any) => {
      if (res.status == 'success') {
        let tempresults = []
        tempresults = res.data.searchResults
        this.searchresultnextpage = res.data.nextSearchPagePresent
        this.totalcustomresults = res.data.totalResults
        if(this.totalcustomresults > 0){
          this.searchresult = [...this.searchresult,...tempresults]
        }
        this.resultdiv = true  //to show result Div
      }
    })
  }


  savePlatformAccessDetails(platform) {
    let data = {
      recordID: this.recordidForPlatform,
      platformAccessed: platform,
      userID:this._localstorageservice.getItem('userid')
    }

    this.searchtoolbox.savePlatFormDetails(data).subscribe((res: any) => {
      if (res.status == 'success') {
        this.recordidForPlatform = res.data.recordID
      }
    })
  }

  showHistory(){
    let data ={
      "startindex":this.start,
      "usernumber": this._localstorageservice.getItem('usernumber')
    }

    this.searchtoolbox.fetchsearchtoolboxhistory(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        let response = res.data;
        this.searchtoolboxhistory = response.searchhistoryrecords
        this.searchtoolboxhistory.map(x => {
          return x.updatedon = GlobalService.getDates(x.updatedon).text;
        })
        this.totalcount = response.totalcount
        
        this.total = this.totalcount
        if (this.start == 0) {
          if (this.end > this.total) {
            this.end = this.total
          }
          if (this.total == 0) {
            this.start = this.total;
            this.end = this.total
          } else if (this.total < 10) {
            this.end = this.total
          } else {
            this.end = this.start + 10;
          }
        }
      }
    })
    this.history = true
  }

  pagination(type) {
    if (type == 'next') {
      this.start = this.start + 10
      this.end = this.start + 10
      if (this.end > this.total)
        this.end = this.total
      this.showHistory();
    } else if (type == 'prev') {
      this.start = this.start - 10
      this.end = this.start + 10
      this.showHistory();
    }
  }

  SearchHistoryResult(data){
    this.resetForm();
    this.jobtitle =  data.jobtitles ? data.jobtitles.split(';'): []
    this.location =  data.locations ? data.locations.split(';'): []
    this.mandatoryskills = data.mandatoryskills ?  data.mandatoryskills.split(';'): []
    this.preferredskills =  data.preferredskills ? data.preferredskills.split(';'): []
    let companies=  data.companies ? data.companies.split(';'): []
    this.industry=  data.industries 
    if(companies.length > 0){
      let companynameobj;
      companies.map(x =>{
        companynameobj={
          company_name : x
        }
        this.companies.push(companynameobj)
      })
    }
  
   let value
   if(this.jobtitle && this.jobtitle.length){
    value = this.jobtitle[this.jobtitle.length - 1]
   }else if(this.preferredskills && this.preferredskills.length){
    value = this.preferredskills[this.preferredskills.length - 1]
   }
   if(value){
    this.getRelatedData('Job Title', value)
   }
    this.history = false
  }

  resetForm() {
    this.jobtitle = []
    this.location = []
    this.companies = []
    this.industry = []
    this.preferredskills = []
    this.mandatoryskills = []
    this.recommendedjobtitle = []
    this.recommendedskills = []
    this.BooleanString = null
    this.booleanSearchURLsArray = null
    this.searchresult = []
    this.searchresultPlatform = null
    this.start = 0
  }

}
